import * as React from "react";
import { useTranslation } from "react-i18next";
import { MenuItem } from "components/bootstrap";
import {
  isAttributeWithFilterOptions,
  isAttributeWithRelatedCollection,
  isDateAttribute,
  isCustomComponentFilter
} from "components/common/EntityFilters/helpers/AttributeIdentification";
import SuggestionsListFilter from "./SuggestionsListFilter";
import GenericFilterInput from "./GenericFilterInput";
import StaticOptionsList from "./StaticOptionsList";
import DateRangeForm from "./DateRangeForm";
const FilterComponent = ({
  allActiveFilters,
  attribute,
  filter = void 0,
  filterValueRenderer,
  onSubmit
}) => {
  if (isCustomComponentFilter(attribute)) {
    const CustomFilterComponent = attribute.filter_component;
    return /* @__PURE__ */ React.createElement(
      CustomFilterComponent,
      {
        attribute,
        filterValueRenderer,
        onSubmit,
        allActiveFilters,
        filter
      }
    );
  }
  if (isAttributeWithFilterOptions(attribute)) {
    return /* @__PURE__ */ React.createElement(
      StaticOptionsList,
      {
        attribute,
        filterValueRenderer,
        onSubmit,
        allActiveFilters
      }
    );
  }
  if (isAttributeWithRelatedCollection(attribute)) {
    return /* @__PURE__ */ React.createElement(
      SuggestionsListFilter,
      {
        attribute,
        filterValueRenderer,
        onSubmit,
        allActiveFilters,
        multiSelect: !filter && !attribute.single_filter
      }
    );
  }
  if (isDateAttribute(attribute)) {
    return /* @__PURE__ */ React.createElement(DateRangeForm, { onSubmit, filter });
  }
  return /* @__PURE__ */ React.createElement(GenericFilterInput, { filter, onSubmit });
};
export const FilterConfiguration = ({
  allActiveFilters,
  attribute,
  filter = void 0,
  filterValueRenderer,
  onSubmit
}) => {
  const { t } = useTranslation("common");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(MenuItem, { header: true }, filter ? t("filters.edit_attribute_filter", { attribute: attribute.title }) : t("filters.create_attribute_filter", { attribute: attribute.title })), /* @__PURE__ */ React.createElement(
    FilterComponent,
    {
      attribute,
      filterValueRenderer,
      onSubmit,
      allActiveFilters,
      filter
    }
  ));
};
export default FilterConfiguration;
